<template>
  <svg width="16" height="18" class="icon-lock-svg" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.625 6H12.6875V4.28571C12.6875 1.92 10.5875 0 8 0C5.4125 0 3.3125 1.92 3.3125 4.28571V6H2.375C1.34375 6 0.5 6.77143 0.5 7.71429V16.2857C0.5 17.2286 1.34375 18 2.375 18H13.625C14.6562 18 15.5 17.2286 15.5 16.2857V7.71429C15.5 6.77143 14.6562 6 13.625 6ZM8 13.7143C6.96875 13.7143 6.125 12.9429 6.125 12C6.125 11.0571 6.96875 10.2857 8 10.2857C9.03125 10.2857 9.875 11.0571 9.875 12C9.875 12.9429 9.03125 13.7143 8 13.7143ZM10.9062 6H5.09375V4.28571C5.09375 2.82 6.39687 1.62857 8 1.62857C9.60312 1.62857 10.9062 2.82 10.9062 4.28571V6Z" fill="white"/>
  </svg>
</template>
<script>
  export default {
    name: 'IconLock'
  }
</script>